import React, { useEffect, useState } from "react";
import Navbar from "../NavBar";
import NewSidebar from "../newSideBar";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import './pageStyle.css'

const FAQPage = () => {
  const [faqs, setFaqs] = useState([]);
  const [isAddingFAQ, setIsAddingFAQ] = useState(false);
  const [newFAQ, setNewFAQ] = useState({
    question: "",
    module: "",
    answers: ["", "", ""],
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const faqsPerPage = 10;
  const localURL = localStorage.getItem("shopURL");
  const [chatLoading, setChatLoading] = useState(true);

  const headers = {
    "Content-Type": "application/json",
    "x-shop-url": localURL,
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewFAQ((prev) => ({ ...prev, [name]: value }));
  };

  const handleAnswerChange = (index, value) => {
    setNewFAQ((prev) => {
      const updatedAnswers = [...prev.answers];
      updatedAnswers[index] = value;
      return { ...prev, answers: updatedAnswers };
    });
  };

  useEffect(() => {
    if (faqs.length > 0) {
      setTotalPages(Math.ceil(faqs.length / faqsPerPage));
    }
  }, [faqs]);

  const getPaginatedFaqs = () => {
    const startIndex = (currentPage - 1) * faqsPerPage;
    const endIndex = startIndex + faqsPerPage;
    return faqs.slice(startIndex, endIndex);
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const fetchQA = async () => {
    try {
      const QAresponse = await axios.get(
        `${process.env.REACT_APP_CHAT_BACKEND_URL}/api/get-qa`,
        { headers }
      );
      setFaqs(QAresponse.data);
    } catch (err) {
      console.error("Error Fetching Q&A", err);
    } finally {
      setChatLoading(false);
    }
  };

  useEffect(() => {
    fetchQA();
  }, []);

  const handleSave = async (e) => {
    try {
      e.preventDefault();
      const response = await axios.post(
        `${process.env.REACT_APP_CHAT_BACKEND_URL}/api/save-qa`,
        { newFAQ },
        { headers }
      );
      if (response.status === 200) {
        alert("Q&A saved successfully!");
        setNewFAQ({ question: "", module: "", answers: ["", "", ""] });
        await fetchQA();
        setIsAddingFAQ(false);
      } else {
        alert("Failed to save Q&A.");
      }
    } catch (error) {
      console.error("Error saving Q&A:", error);
      alert("An error occurred while saving Q&A.");
    }
  };

  return (
    <div className="faq-dashboard">
      <Navbar />
      <div className="faq-layout">
        <NewSidebar />
        <div className="faq-main-content">
          {chatLoading ? (
            <div className="faq-loading-overlay">
              <Spinner animation="border" variant="primary" className="faq-spinner" />
            </div>
          ) : (
            <div className="faq-content-area">
              {isAddingFAQ ? (
                <div className="faq-form-container">
                  <div className="faq-form-header">
                    <h3 className="faq-form-title">Add New FAQ</h3>
                    <nav className="faq-breadcrumb">
                      <button 
                        className="faq-breadcrumb-back"
                        onClick={() => setIsAddingFAQ(false)}
                      >
                        &larr; Back to FAQ List
                      </button>
                    </nav>
                  </div>
                  
                  <div className="faq-form-card">
                    <div className="faq-form-body">
                      <h4 className="faq-form-subtitle">FAQ Details</h4>
                      <form className="faq-form" onSubmit={handleSave}>
                        <div className="faq-form-group">
                          <label htmlFor="question">Question</label>
                          <input
                            type="text"
                            className="faq-form-control"
                            id="question"
                            name="question"
                            value={newFAQ.question}
                            placeholder="Enter the question here"
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                        
                        <div className="faq-form-group">
                          <label htmlFor="module">Module</label>
                          <select
                            className="faq-form-control"
                            id="module"
                            name="module"
                            value={newFAQ.module}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="">Select a module</option>
                            <option value="E-Commerce">E-Commerce</option>
                            <option value="Hospital">Hospital</option>
                            <option value="Software">Software</option>
                            <option value="Real Estate">Real Estate</option>
                          </select>
                        </div>
                        
                        <div className="faq-form-group">
                          <label>Answers</label>
                          {newFAQ.answers.map((answer, index) => (
                            <div key={index} className="faq-answer-group">
                              <textarea
                                className="faq-form-control"
                                rows="3"
                                placeholder={`Answer ${index + 1}${
                                  index === 0 ? " (Required)" : ""
                                }`}
                                value={answer}
                                onChange={(e) =>
                                  handleAnswerChange(index, e.target.value)
                                }
                                required={index === 0}
                              ></textarea>
                            </div>
                          ))}
                        </div>
                        
                        <div className="faq-form-actions">
                          <button
                            type="button"
                            className="faq-cancel-btn"
                            onClick={() => setIsAddingFAQ(false)}
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="faq-save-btn"
                          >
                            Save FAQ
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="faq-list-container">
                  <div className="faq-list-header">
                    <h3 className="faq-list-title">FAQ Management</h3>
                    <button
                      className="faq-add-btn"
                      onClick={() => setIsAddingFAQ(true)}
                    >
                      <i className="mdi mdi-plus"></i> Add New FAQ
                    </button>
                  </div>
                  
                  <div className="faq-list-card">
                    <div className="faq-table-container">
                      <table className="faq-table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Question</th>
                            <th>Module</th>
                            <th>Answers</th>
                          </tr>
                        </thead>
                        <tbody>
                          {getPaginatedFaqs().map((faq, index) => (
                            <tr key={faq.id}>
                              <td>
                                {(currentPage - 1) * faqsPerPage + index + 1}
                              </td>
                              <td className="faq-question-cell">{faq.question}</td>
                              <td className="faq-module-cell">
                                <span className="faq-module-badge">
                                  {faq.module}
                                </span>
                              </td>
                              <td className="faq-answers-cell">
                                <div className="faq-answers-list">
                                  {faq.answers
                                    .filter((a) => a)
                                    .map((ans, idx) => (
                                      <div key={idx} className="faq-answer-item">
                                        {ans}
                                      </div>
                                    ))}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      
                      {faqs.length === 0 && (
                        <div className="faq-empty-state">
                          <i className="mdi mdi-help-circle-outline"></i>
                          <p>No FAQs found</p>
                          <button
                            className="faq-add-btn"
                            onClick={() => setIsAddingFAQ(true)}
                          >
                            <i className="mdi mdi-plus"></i> Add Your First FAQ
                          </button>
                        </div>
                      )}
                      
                      {totalPages > 1 && (
                        <div className="faq-pagination">
                          <button
                            className="faq-pagination-btn"
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                          >
                            <i className="mdi mdi-chevron-left"></i> Previous
                          </button>
                          
                          <div className="faq-page-numbers">
                            {Array.from({ length: totalPages }, (_, i) => (
                              <button
                                key={i + 1}
                                className={`faq-page-btn ${
                                  currentPage === i + 1 ? "active" : ""
                                }`}
                                onClick={() => handlePageChange(i + 1)}
                              >
                                {i + 1}
                              </button>
                            ))}
                          </div>
                          
                          <button
                            className="faq-pagination-btn"
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                          >
                            Next <i className="mdi mdi-chevron-right"></i>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FAQPage;